import {isPlainObject} from "@utils/object";

const UseTestData = ({
   labelText = 'Use test data',
   useTestData = false,
   setUseTestData,
   formData,
   setFormData,
   testData = {}
}) => {
   
   if(process.env.NEXT_PUBLIC_SHOW_TEST_DATA_BLOCK !== '1') {
      return null;
   }

   testData = isPlainObject(testData) ? testData : {};
   
   return (
      <div className="alert alert-warning">
         
         <div className="form-check">
            <input className="form-check-input" type="checkbox" value="1" id="defaultCheck1" checked={useTestData} onChange={(e) => {
               
               setUseTestData(e.target.checked);
               
               if (e.target.checked) {
                  setFormData({
                     ...formData,
                     ...testData
                  })
               } else {
                  setFormData({})
               }
               
               
            }}  />
            <label className="form-check-label" htmlFor="defaultCheck1">
               {labelText}
            </label>
         </div>
      </div>
   );
   
};

export default UseTestData;